import { IconButton } from "@mui/material"
import { red } from "@mui/material/colors"
import { BoxFR } from "components/BoxCustom"
import { expenseJobOrderColNm } from "constants/expenseJobOrderConstant"
import { pettyCashColNm } from "pages/Menu1/PettyCash/constant"
import { ArticleRounded, CloseRounded } from "resource/muiImport"


export const pcTrnsColumns = (handleRemoveTmpUsrAccId) => [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "UsrNNm",
    headerName: pettyCashColNm.UsrNNm,
    width: 100,
    cellClassName: ({row}) => row.TmpUsrAccId ? 'tmp-usr-acc-id-cell': '',
    renderCell: ({row, value})=> row.TmpUsrAccId ? (
      <BoxFR sx={{gap: 0}}>
        <IconButton sx={{p: 0}} onClick={handleRemoveTmpUsrAccId(row)}>
          <CloseRounded fontSize="small" sx={{color: red[800]}} />
        </IconButton>
        {value}
      </BoxFR>
    ): null
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    flex: 1,
    minWidth: 120,
  },

  {
    field: "InOutAmnt",
    headerName: pettyCashColNm.InOutAmnt,
    width: 80,
    align: 'right',
  },
  {
    field: "IsCmpt",
    headerName: '',
    width: 30,
    align: 'center',
    valueFormatter: (params) => params.value ? "✔" : "",
  },
]


export const pcItmColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    flex: 1,
    minWidth: 120,
  },

  {
    field: "InOutAmnt",
    headerName: pettyCashColNm.InOutAmnt,
    width: 80,
    align: 'right',
  },
]



export const expenseJobOrderColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "ExpNm",
    headerName: expenseJobOrderColNm.ExpNm,
    flex: 1,
    minWidth: 120,
  },

  {
    field: "Total",
    headerName: expenseJobOrderColNm.Total,
    width: 80,
  },
]